<template lang="pug">
.receipts
  table.ui.very.basic.unstackable.table
    tbody
      tr(v-for='receipt in receipts', v-if='price(receipt) !== 0')
        td.four.wide.right.aligned.name {{receipt.name}}
        td.three.wide.right.aligned.quantity {{quantity_unit(receipt)}} {{to_brackets(receipt.unit_note)}}
        td.three.wide.right.aligned.quantity {{$formatters.money(receipt.unit_price)}}
        td.four.wide.right.aligned.money {{$formatters.money(price(receipt))}}
        td.two.wide
    tfoot
      th.four.wide.right.aligned.summary 合计
      th.three.wide
      th.three.wide
      th.four.wide.right.aligned.money {{$formatters.money(summary.price)}}
      th.two.wide
</template>

<script>
export default {
  name: 'receipts',
  props: {
    receipts: {
      default: [],
    },
  },
  computed: {
    summary() {
      const summary = {
        quantity: 0,
        price: 0,
      }
      for (const receipt of this.receipts) {
        summary.quantity += receipt.quantity
        summary.price += this.price(receipt)
      }
      return summary
    },
  },
  methods: {
    to_brackets(str) {
      return str ? `(${str})` : ''
    },
    quantity_unit(receipt) {
      if (!receipt.quantity)
        return ''
      else if (!receipt.unit)
        return receipt.quantity
      return `${receipt.quantity} ${receipt.unit}`
    },
    price(receipt) {
      if (receipt.price != null)
        return receipt.price
      return (receipt.unit_price || 0) * (receipt.quantity === undefined ? 1 : (receipt.quantity || 0))
    },
  },
}
</script>



// WEBPACK FOOTER //
// Receipts.vue?620ca2b8